module.exports = __webpack_public_path__ + "ed6eafcb55584c1c32b942bd2cc8ccbc.MP3";